import {AsyncPipe, NgClass}                                               from '@angular/common';
import {Component, HostListener, inject, Injector, runInInjectionContext} from '@angular/core';
import {RouterOutlet}                                                     from '@angular/router';
import {gsap}                                                             from 'gsap'
import {ScrollToPlugin}                                                   from 'gsap/ScrollToPlugin';
import {DataFactoryService}                                               from '../lib/logr-services/data/data-factory.service';
import {UiVideoBgComponent}                                               from '../lib/logr-ui/comps/ui/ui-video-bg/ui-video-bg.component';
import {MenuCrudComponent}                                                from '../lib/logr-ui/menus/comps/menu-crud/menu-crud.component';
import {MenuDragComponent}                                                from '../lib/logr-ui/menus/comps/menu-drag/menu-drag.component';
import {MenuBaseService}                                                  from '../lib/logr-ui/menus/utils/menu-base.service';

gsap.registerPlugin(ScrollToPlugin)

@Component({
			   selector   : 'app-sys',
			   imports : [
				   MenuCrudComponent,
				   UiVideoBgComponent,
				   RouterOutlet,
				   NgClass,
				   MenuDragComponent,
				   AsyncPipe
			   ],
			   templateUrl: './sys.component.html',
			   styleUrl: './sys.component.css'
		   })
export class SysComponent {
	injector = inject(Injector)
	svcDataFactory = inject(DataFactoryService);

	svcMenuBase = inject(MenuBaseService)


	@HostListener('document:visibilitychange', ['$event'])
	async onVisibilityChange() {
		await runInInjectionContext(this.injector, async () => {
			// Ensures we only act when the app becomes visible
			if (document.visibilityState === 'visible') {
				await this.svcDataFactory.svcDataOura.initializeData();
				await this.svcDataFactory.svcDataRize.initializeData();
			}
		});
	}


	constructor() {
		this.svcDataFactory.initData().then((text) => {
			console.info(text)
			// this.svcMenuBase.menuCrudToggle(5, 'note')
		});
	}


}
